import React from 'react';
import { evaluateFormula } from '../../../utils/formulaEvaluator';

/**
 * FieldFactory - Renderizador dinámico de campos según tipo
 * 
 * Tipos soportados:
 * - text: Texto simple
 * - textarea: Texto largo
 * - select: Lista desplegable
 * - number: Número
 * - checkbox: Casilla de verificación
 * - date: Fecha
 */
const FieldFactory = ({ campo, valor, onChange, valores }) => {
    
    const handleChange = (e) => {
        const newValue = campo.tipo === 'checkbox' ? e.target.checked : e.target.value;
        onChange(campo.id, newValue);
    };
    
    switch (campo.tipo) {
        case 'text':
            return (
                <div className="form-group">
                    <label>
                        {campo.label} 
                        {campo.requerido && <span className="text-danger"> *</span>}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={valor || ''}
                        onChange={handleChange}
                        required={campo.requerido}
                        placeholder={campo.placeholder || ''}
                    />
                </div>
            );
            
        case 'textarea':
            return (
                <div className="form-group">
                    <label>
                        {campo.label}
                        {campo.requerido && <span className="text-danger"> *</span>}
                    </label>
                    <textarea
                        className="form-control"
                        rows={campo.rows || 3}
                        value={valor || ''}
                        onChange={handleChange}
                        required={campo.requerido}
                        placeholder={campo.placeholder || ''}
                    />
                </div>
            );
            
        case 'select':
            return (
                <div className="form-group">
                    <label>
                        {campo.label}
                        {campo.requerido && <span className="text-danger"> *</span>}
                    </label>
                    <select
                        className="form-control"
                        value={valor || ''}
                        onChange={handleChange}
                        required={campo.requerido}
                    >
                        <option value="">-- Seleccione --</option>
                        {campo.opciones && campo.opciones.map((opcion, index) => (
                            <option key={index} value={opcion}>{opcion}</option>
                        ))}
                    </select>
                </div>
            );
            
        case 'number':
            return (
                <div className="form-group">
                    <label>
                        {campo.label}
                        {campo.requerido && <span className="text-danger"> *</span>}
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        value={valor || ''}
                        onChange={handleChange}
                        required={campo.requerido}
                        placeholder={campo.placeholder || ''}
                        min={campo.min}
                        max={campo.max}
                        step={campo.step || '1'}
                    />
                </div>
            );
            
        case 'checkbox':
            return (
                <div className="form-check" style={{ marginBottom: '15px' }}>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={valor || false}
                        onChange={handleChange}
                        id={`campo_${campo.id}`}
                    />
                    <label className="form-check-label" htmlFor={`campo_${campo.id}`}>
                        {campo.label}
                    </label>
                </div>
            );
            
        case 'date':
            return (
                <div className="form-group">
                    <label>
                        {campo.label}
                        {campo.requerido && <span className="text-danger"> *</span>}
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        value={valor || ''}
                        onChange={handleChange}
                        required={campo.requerido}
                    />
                </div>
            );
            
        case 'formula': {
            const resultado = evaluateFormula(campo.formula, valores || {});
            const tieneResultado = resultado.value !== null;
            const textoMostrar = tieneResultado
                ? resultado.value.toFixed(campo.decimales ?? 2)
                : (resultado.error || 'Faltan datos');
            
            return (
                <div className="form-group">
                    <label>{campo.label}</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            value={textoMostrar}
                            readOnly
                            style={tieneResultado ? {} : { color: '#999', fontStyle: 'italic' }}
                        />
                        {campo.unidad && (
                            <div className="input-group-append">
                                <span className="input-group-text">{campo.unidad}</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
            
        default:
            return (
                <div className="alert alert-warning">
                    <i className="fas fa-exclamation-triangle"></i> Tipo de campo no soportado: {campo.tipo}
                </div>
            );
    }
};

export default FieldFactory;
